<template>
  <div class="OverviewsItem OverviewsAccesesItemTeam flex justify-between items-center space-x-2 w-full hover:bg-gray-100 border-b border-gray-400 cursor-pointer px-2">
    <div class="flex justify-center items-center space-x-2.5">
      <ui-pictogram :force-content="team.team.user_count"/>
    </div>
    <span class="OverviewsItemTeamName text-sm w-full truncate">
      {{ team.team.name }}
    </span>
    <div class="flex justify-between items-center space-x-1">
      <aw-icon
        :icon="team.edit ? 'pen' : 'eye-opened'"
        class="w-6 h-6 text-bc-blue"
      />
      <aw-icon 
        icon="download" 
        class="w-6 h-6 text-gray-400"
        :class="team.download ? 'text-bc-blue' : 'text-gray-400'"
      />
      <aw-icon 
        icon="chevron-right" 
        class="toggleIcon w-6 h-6 text-gray-400"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    team: Object,
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.OverviewsAccesesItemTeam {
  .OverviewsItemTeamName {
    max-width: calc(100% - 1.625rem - 78px);
  }
}

.OverviewsAccesesItemTeam:hover {
  .toggleIcon {
    @apply text-bc-blue;
  }
}
</style>
